import React from "react";
class PDPImageryThumbControl extends React.Component {
  handleClick = () => {
    this.props.onClick(this.props.direction);
  };

  render() {
    var wrapperClassName = "thumb-controls thumb-" + this.props.direction + " " + this.props.className;

    return (
      <div className={wrapperClassName} onClick={this.handleClick}>
        <span className="arrow" />
      </div>
    );
  }
}

export default PDPImageryThumbControl;
